import { pictureActions } from '../actions';

export default function picture ( initialState = {}, action ) {
    const newState = { ...initialState };

    switch ( action.type ) {
        case pictureActions.SET_PICTURE: return setPicture( newState, action );
        default: return newState;
    }
}

function setPicture ( newState, action ) {
    delete action.type;
    newState = Object.assign( {}, { ...action } );
    return newState;
}


// WEBPACK FOOTER //
// src/client/components/site/features/profile/reducers/picture.js